module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-a5a4beba6a3c8f6bb99393317fed9e17.png";